import React, { createContext, useContext, ReactNode } from 'react';

interface PayPalContextType {
  clientId: string;
}

const PayPalContext = createContext<PayPalContextType | undefined>(undefined);

export const usePayPal = () => {
  const context = useContext(PayPalContext);
  if (!context) {
    throw new Error('usePayPal must be used within a PayPalProvider');
  }
  return context;
};

interface PayPalProviderProps {
  children: ReactNode;
}

export const PayPalProvider: React.FC<PayPalProviderProps> = ({ children }) => {
  const clientId = import.meta.env.VITE_PAYPAL_CLIENT_ID || 'sandbox';

  return (
    <PayPalContext.Provider value={{ clientId }}>
      {children}
    </PayPalContext.Provider>
  );
};
